import { h } from "@stencil/core";
export class ChTree {
    constructor() {
        this.checkbox = false;
        this.checked = false;
        this.toggleCheckboxes = false;
        this.nestedTree = false;
        this.mainTree = false;
    }
    el;
    ulTree;
    componentWillLoad() {
        // Check if this tree is nested
        const parentElementTagName = this.el.parentElement.tagName;
        if (parentElementTagName === "CH-TREE-ITEM") {
            this.nestedTree = true;
        }
        // if this is the main tree...
        const parentTreeTagName = this.el.parentElement.tagName;
        if (parentTreeTagName !== "CH-TREE-ITEM") {
            this.mainTree = true;
        }
    }
    liItemClickedHandler() {
        // Remove 'selected' state from previous selected item
        const chTreeItems = this.el.querySelectorAll("ch-tree-item");
        chTreeItems.forEach(chTreeItem => {
            chTreeItem.selected = false;
        });
    }
    toggleIconClickedHandler() {
        // Update not leaf tree items vertical line height
        const treeItems = this.el.querySelectorAll("ch-tree-item.not-leaf");
        treeItems.forEach(treeItem => {
            treeItem.updateTreeVerticalLineHeight();
        });
    }
    /**
     * @returns an array of the ch-tree-items that are checked. Each array item is an object with "id" and "innerText".
     */
    async getChecked() {
        const allTreeItems = this.el.querySelectorAll("ch-tree-item");
        const checkedTreeItems = [];
        if (allTreeItems.length) {
            allTreeItems.forEach(treeItem => {
                if (treeItem.checked) {
                    checkedTreeItems.push({ id: treeItem.id });
                }
            });
        }
        return checkedTreeItems;
    }
    render() {
        return this.mainTree ? (h("div", { class: {
                tree: true,
                "main-tree": true
            } }, h("div", { class: "main-tree-container" }, h("ul", { ref: el => (this.ulTree = el) }, h("slot", null))))) : (h("div", { class: {
                tree: true,
                "nested-tree": true
            } }, h("ul", { ref: el => (this.ulTree = el) }, h("slot", null))));
    }
    static get is() { return "ch-tree"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-tree.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-tree.css"]
        };
    }
    static get properties() {
        return {
            "checkbox": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all this tree tree-items to have a checkbox"
                },
                "attribute": "checkbox",
                "reflect": false,
                "defaultValue": "false"
            },
            "checked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all this tree tree-items to have the checkbox checked"
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "false"
            },
            "toggleCheckboxes": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all the childen item's checkboxes to be checked when the parent item checkbox is checked, or to be unchecked when the parent item checkbox is unckecked."
                },
                "attribute": "toggle-checkboxes",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "nestedTree": {},
            "mainTree": {}
        };
    }
    static get methods() {
        return {
            "getChecked": {
                "complexType": {
                    "signature": "() => Promise<checkedChTreeItem[]>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "checkedChTreeItem": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/tree/ch-tree.tsx",
                            "id": "src/components/tree/ch-tree.tsx::checkedChTreeItem"
                        }
                    },
                    "return": "Promise<checkedChTreeItem[]>"
                },
                "docs": {
                    "text": "",
                    "tags": [{
                            "name": "returns",
                            "text": "an array of the ch-tree-items that are checked. Each array item is an object with \"id\" and \"innerText\"."
                        }]
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "liItemClicked",
                "method": "liItemClickedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "toggleIconClicked",
                "method": "toggleIconClickedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=ch-tree.js.map
